import script from "./DocBadges.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocBadges.vue?vue&type=script&setup=true&lang=ts"

import "./DocBadges.vue?vue&type=style&index=0&id=1f609801&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f609801"]])

export default __exports__